export default __webpack_public_path__ + "static/atrium_img1-bb4c5c8df76434205c4ffe1ce4d032a6.png";